export enum BloodPressure {
  HIGH = 'high',
  LOW = 'low',
  NORMAL = 'normal',
  UNKNOWN = 'unknown'
}

export enum Diabetes {
  TYPE1 = 'type1',
  TYPE2 = 'type2'
}

export class HealthLimitationSet {
  id: number
  shoulder: boolean = false
  knee: boolean = false
  hip: boolean = false
  feetAnkle: boolean = false
  elbow: boolean = false
  handWrist: boolean = false
  cervicalSpine: boolean = false
  lumbarSpine: boolean = false
  thoracicSpine: boolean = false
  bloodPressure: BloodPressure = BloodPressure.UNKNOWN
  heartAttack: boolean = false
  anginaPectoris: boolean = false
  cardiacArrhythmias: boolean = false
  circulatoryDisorders: boolean = false
  stroke: boolean = false
  diabetes: Diabetes | null = null
  rheumatism: boolean = false
  cancer: boolean = false
  osteoporosis: boolean = false
  obesity: boolean = false
  varices: boolean = false
  gaveBirthLast6Months: boolean = false
  pregnant: boolean = false
  medication: string = ''
  notes: string = ''
  operations: string = ''
  hypothyroidism: boolean = false
  hyperthyroidism: boolean = false
  asthmaBronchiale: boolean = false
  asthmaAllergic: boolean = false
  asthmaExertional: boolean = false
  waterConsumption: string | null = null
  mealFrequency: string | null = null
  behaviourInfo: string | null = null

  constructor (attributes?) {
    Object.assign(this, attributes)
  }
}
